import React from 'react'
import PropTypes from 'prop-types' 
import { graphql, navigate }  from 'gatsby'

import Layout from '../components/Layout'
import Seo from '../components/Seo'
import { Container } from '../components/styles/Layout.styles'
import Row from '../components/Row'
import Column from '../components/Column'
import Article from '../components/Article'

import H4 from '../components/H4'
import Div from '../components/Div/Div.styles'
import Button from '../components/Button/Button'
import Hr from '../components/Hr'
import {
  contentPost,
  dots,
} from '../components/styles/PostBlog.styles'
import { normalizeDate } from '../utils/helpers';

export const PageTemplate = ({
  data
}) => {
  const { wordpressPost: post } = data
  console.log(data)

  const posts = data.allWordpressPost.edges

  return (
    <section>
      <Div
        px={[16, 16, 24, 24]}
        alignItems={['center']}
      >
        <Container>
          <Div
            maxWidth={['100%', 390, 600]}
            alignItems={['center', 'center', 'stretch']}
          >
            <Row
              pt={[50]}
              pb={[16]}
              mx={[-16, -16, -24, -24]}
            >
              <Column
                width={[1]}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <Div
                  flexDirection='column'
                  alignItems='center'
                  justifyContent='left'
                  maxWidth={['100%', 344, '100%']}
                >
                  <Div
                    style={{
                      fontSize: 11.8,
                      fontWeight: 600,
                      lineHeight: 1.36,
                      letterSpacing: 2,
                      color: 'rgba(0, 0, 0, 0.6)',
                      textTransform: 'uppercase',
                      marginBottom: 8
                    }}
                  >
                    {normalizeDate(post.date)} • Leitura 5 min
                  </Div>
                  <H4
                    selected
                    on='onSurface'
                    variant='highEmphasis'
                    style={{
                      width: '100%'
                    }}
                  >
                    {post.title}
                  </H4>
                </Div>
              </Column>
            </Row>
            <Row
              flexDirection={['column']}
              css={contentPost}
            >
              <Column
                mt={[30]}
                mb={[50]}
                px={[null]}
                dangerouslySetInnerHTML={{
                  __html: post.content
                }}
              />
            </Row>
            <Row
              mb={[50]}
            >
              <Div
                textAlign={['center']}
                justifyContent={['center']}
                flexDirection={['row']}
              >
                <div css={dots} />
                <div css={dots} />
                <div css={dots} />
              </Div>
            </Row>
          </Div>
        </Container>
        <Hr
          lineColor='lightPeriwinkle'
          m={['0 0 40px']}
          maxWidth={['100%', 422, 728, 813]}
          style={{
            opacity: 0.5
          }}
        />
        <Container>
          <Div
            maxWidth={['100%', 390, 813]}
            alignItems={['center', 'center', 'stretch']}
          >
            <Row
              pb={[50, 70]}
              mx={[-16, -16, -24, -24]}
            >
              <Column
                width={[1]}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <Div
                  flexDirection='row'
                  alignItems='center'
                  justifyContent='left'
                  maxWidth={['100%', 344, '100%']}
                >
                  <H4
                    selected
                    on='onSurface'
                    variant='highEmphasis'
                  >
                    Posts Relacionados
                  </H4>
                </Div>
                {posts.length > 0
                  && Array(Math.ceil(posts.length / 2)).slice(0, 2).fill(0).map((item, i) => {
                    return (
                      <Row
                        key={`post-row-${i}`}
                        flexDirection={['column', 'column', 'row']}
                        maxWidth={['100%', 344, '100%']}
                        width={['100%']}
                        mt={[40]}
                      >
                        {posts.slice(i === 0 ? 0 : i * 2, 2 + i * 2).map((post, x) => (
                          <Column
                            key={`post-item-${x + i}`}
                            width={[1, 1, 1/2]}
                            mb={[32, 24, 0]}
                          >
                            <Article
                              title={post.node.title}
                              slug={post.node.slug}
                              meta={{
                                date: post.node.date,
                                duration: '6 min'
                              }}
                              img={post.node.featured_media && post.node.featured_media.localFile.publicURL}
                            />
                            <Hr
                              lineColor='lightPeriwinkle'
                              maxWidth={[50]}
                              style={{
                                marginLeft: 0
                              }}
                            />
                          </Column>
                        ))}
                      </Row>
                    )
                })}
                <Button
                  onClick={() => navigate('/blog')}
                  schema='white'
                  outlined
                  selected
                  variant='base'
                  on='onSurface'
                  width={['100%']}
                  maxWidth={['290px']}
                  style={{
                    display: 'flex',
                    border: '1px solid rgba(0, 0, 0, 0.12)',
                    margin: '0 auto',
                    marginTop: 50
                  }}
                >
                  voltar para o blog
                </Button>
              </Column>
            </Row>
          </Div>
        </Container>
      </Div>
    </section>
  )
}

PageTemplate.propTypes = {
  data: PropTypes.object
}

const StaticPage = ({data}) => {
  return (
    <Layout>
      <Seo title='Blog' />
      <PageTemplate
        title='Blog'
        data={data}
      />
    </Layout>
  )
}

StaticPage.propTypes = {
  data: PropTypes.object
}

export const pageQuery = graphql`
  fragment PostListFields on wordpress__POST {
    id
    slug
    content
    date(formatString: "DD MM YYYY")
    title
    featured_media {
      localFile {
        publicURL
      }
    }
  }
  query BlogPostByID($id: String!) {
    wordpressPost(id: { eq: $id }) {
      id
      title
      slug
      content
      date(formatString: "DD MM YYYY")
      categories {
        name
        slug
      }
      author {
        name
        slug
      }
    }
    allWordpressPost(
      sort: { fields: date, order: DESC }
      limit: 4
    ) {
      edges {
        node {
          ...PostListFields
        }
      }
    }
    image1: file(relativePath: { eq: "blog.png" }) {
      childImageSharp {
        fluid(maxWidth: 487) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default StaticPage
